<template>
  <div class="hpiframe">
    <iframe
        class="hpiframe"
        allowfullscreen
        :src="url"
    >
    </iframe>

  </div>

</template>

<script>
export default {
  props: {
    homeplanBaseUrl: { type: String, required: true},
    homeplanAccessPoint: { type: String, required: true},
    homeplanSaveId : { type : String, required : true },
    updateToken : { type : String, required : true }
  },
  data: function () {
    return {
      url : this.homeplanBaseUrl + '?ap=' + this.homeplanAccessPoint + '&save=' + this.homeplanSaveId +
          '&updateToken=' + this.updateToken + '&overwriteSaveOnScrapperSave=true',
    }
  },

  beforeUnmount() {
    window.removeEventListener('message', this.receiveMessage, false);
  },
  mounted: function () {
    window.addEventListener('message', this.receiveMessage, false);
  },

  methods: {
    receiveMessage: function (event) {
      if (event.data.type !== 'mdc-end-of-tunnel-notification') {
        return;
      }

      if (event.data.content !== undefined && event.data.content.saveId !== undefined) {
        this.prepareSaveToConvert(event.data.content.saveId);
      }
    },

    prepareSaveToConvert: function (saveId) {
      let params = {
        'homeplan_save_id' : saveId
      };

      axios.put('/api/v1/homeplan_saves/' + this.homeplanSaveId  + '/prepare_to_convert', params)
      .then(response => {

      }).catch(error => { this.$httpError({ error: error }); });
    }
  }


}
</script>

<style scoped>
.hpiframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0px;
  margin: 0px;
  padding: 0px;
  border: none;
}
</style>